module.exports = __webpack_public_path__ + "img/0x639A647fbe20b6c8ac19E48E2de44ea792c62c5C.86b356aa.png";